const state = {
    availableOptions: null,
    vehicle: null,
    techSpecs: null,
    standardSpec: null,
    paintOptions: null,
    gallery: null,
    pchOffer: null,
    selectedPaint: null,
    newVehiclesInStock: [],
    cachedVehicleData: {},
};

// getters
const getters = {
};

// actions
const actions = {
    getVehicleData({commit, state}, id) {
        return new Promise((resolve, reject) => {
            if (typeof state.cachedVehicleData[id] != 'undefined') {
                commit('setTechSpecs', state.cachedVehicleData[id].techSpecs);
                commit('setStandardSpec', state.cachedVehicleData[id].standardSpec);
                commit('setVehicle', state.cachedVehicleData[id].vehicle);
                commit('setPaintOptions', state.cachedVehicleData[id].paintOptions);
                commit('setGallery', state.cachedVehicleData[id].gallery);
                commit('setNewVehiclesInStock', state.cachedVehicleData[id].stock);
                commit('setPchOffer', state.cachedVehicleData[id].pchOffer);
                resolve({data: state.cachedVehicleData[id], instant: true});
                return;
            }
            if (typeof window.newVehicleDetails != 'undefined' && typeof window.newVehicleDetails.id != 'undefined' && window.newVehicleDetails.id == id) {
                commit('setAvailableOptions', window.newVehicleOptions);
                commit('setTechSpecs', window.newVehicleTechSpecs);
                commit('setStandardSpec', window.newVehicleStandardSpec);
                commit('setVehicle', window.newVehicleDetails);
                commit('setPaintOptions', window.newVehiclePaintOptions);
                commit('setGallery', window.newVehicleGallery);
                commit('setNewVehiclesInStock', window.newVehiclesInStock);
                commit('setPchOffer', window.newVehiclesPCHOffer);
                commit('loadVehicleIntoCache', {
                    vehicle: window.newVehicleDetails,
                    techSpecs: window.newVehicleTechSpecs,
                    standardSpec: window.newVehicleStandardSpec,
                    paintOptions: window.newVehiclePaintOptions,
                    gallery: window.newVehicleGallery,
                    stock: window.newVehiclesInStock,
                    pchOffer: window.newVehiclesPCHOffer,
                });
                resolve({data: state.cachedVehicleData[id], instant: false});
                return;
            }
            const params = {};
            if (state.availableOptions == null) {
                params.getAvailableOptions = true;
            }
            axios.get('/api/new/vehicle/' + id, {params}).then(response => {
                if (state.availableOptions == null) {
                    commit('setAvailableOptions', response.data.options);
                }
                commit('setTechSpecs', response.data.techSpecs);
                commit('setStandardSpec', response.data.standardSpec);
                commit('setVehicle', response.data.vehicle);
                commit('setPaintOptions', response.data.paintOptions);
                commit('setGallery', response.data.gallery);
                commit('setNewVehiclesInStock', response.data.stock);
                commit('setPchOffer', response.data.pchOffer);
                commit('loadVehicleIntoCache', response.data);
                resolve({data: response.data, instant: false});
            })
            .catch(error => {
                console.error('Error getting vehicle data', error);
                reject();
            })
        });
    },
};

const mutations = {
    loadVehicleIntoCache(state, vehicleToCache) {
        state.cachedVehicleData[vehicleToCache.vehicle.id] = vehicleToCache;
    },
    setAvailableOptions(state, availableOptions) {
        const cleansedOptions = [];
        for (let index = 0, len = availableOptions.length; index < len; index++) {
            const availableOption = availableOptions[index];
            if (typeof availableOption['slug'] == 'undefined') {
                continue;
            }
            if (typeof availableOption['id'] == 'undefined') {
                continue;
            }
            if (typeof availableOption['version'] == 'undefined') {
                continue;
            }
            if (typeof availableOption['fuel_type'] == 'undefined') {
                continue;
            }

            if (availableOption.fuel_type == 'Electric') {
                availableOption.electric = true;
            } else if (availableOption.fuel_type.toLocaleLowerCase().indexOf('hybrid') >= 0) {
                availableOption.electric = true;
            } else {
                availableOption.electric = false;
            }

            cleansedOptions.push(availableOption);
        }
        state.availableOptions = cleansedOptions;
    },
    setVehicle(state, vehicle) {
        state.vehicle = vehicle;
    },
    setTechSpecs(state, techSpecs) {
        state.techSpecs = techSpecs;
    },
    setStandardSpec(state, standardSpec) {
        state.standardSpec = standardSpec;
    },
    setPaintOptions(state, paintOptions) {
        // If we haven't already got a paint selected, see if we can grab the default paint from the new_vehicle_trim
        let selectedPaint = null;
        if (typeof state.vehicle.new_vehicles_trim != 'undefined' && typeof state.vehicle.new_vehicles_trim.imagin_paint_option != 'undefined' && state.vehicle.new_vehicles_trim.imagin_paint_option && state.vehicle.new_vehicles_trim.imagin_paint_option.length > 0) {
            for (let index = 0, paintOptionsLength = paintOptions.length; index < paintOptionsLength; index++) {
                if (paintOptions[index].name == state.vehicle.new_vehicles_trim.imagin_paint_option) {
                    selectedPaint = paintOptions[index];
                    break;
                }
            }
            // If there's an existing paint option, make sure it actually exists before continuing
            if (state.selectedPaint !== null) {
                for (let index = 0, paintOptionsLength = paintOptions.length; index < paintOptionsLength; index++) {
                    if (paintOptions[index].id == state.selectedPaint.id) {
                        selectedPaint = paintOptions[index];
                        break;
                    }
                }
            }
        }

        let firstPaint = null;
        if (selectedPaint == null) {
            for (let index = 0, paintOptionsLength = paintOptions.length; index < paintOptionsLength; index++) {
                if (firstPaint === null) {
                    firstPaint = paintOptions[index];
                    if (state.selectedPaint === null) {
                        break;
                    }
                }

                if (paintOptions[index].id == state.selectedPaint.id) {
                    selectedPaint = paintOptions[index];
                    break;
                }
            }
        }

        state.paintOptions = paintOptions;
        if (selectedPaint !== null) {
            state.selectedPaint = selectedPaint;
        } else {
            state.selectedPaint = firstPaint;
        }
    },
    setSelectedPaint(state, selectedPaint) {
        state.selectedPaint = selectedPaint;
    },
    setGallery(state, gallery) {
        state.gallery = gallery;
    },
    setNewVehiclesInStock(state, newVehiclesInStock) {
        state.newVehiclesInStock = newVehiclesInStock;
    },
    setPchOffer(state, pchOffer) {
        state.pchOffer = pchOffer;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};